module.exports = __webpack_public_path__ + "img/download.32aad419.svg";